module.exports = __webpack_public_path__ + "img/n9.88bda440.png";